import React, { useEffect, useState } from 'react';
import Modal from '../../BaseComponents/Modal';
import TextArea from '../../BaseComponents/TextArea';
import Button from '../../BaseComponents/Button';
import './FollowupStatusModal.scss';

type FollowupStatusModalProps = {
  isOpen: boolean;
  statusLabel: string;
  onClose: () => void;
  onConfirm: (comment: string) => void;
  isSubmitting: boolean;
};

const FollowupStatusModal: React.FC<FollowupStatusModalProps> = ({
  isOpen,
  statusLabel,
  onClose,
  onConfirm,
  isSubmitting,
}) => {
  const [comment, setComment] = useState('');
  const [commentError, setCommentError] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setComment('');
      setCommentError(false);
    }
  }, [isOpen, statusLabel]);

  const handleClose = () => {
    setComment('');
    setCommentError(false);
    onClose();
  };

  const handleConfirm = () => {
    const trimmed = comment.trim();
    if (!trimmed) {
      setCommentError(true);
      return;
    }
    setCommentError(false);
    onConfirm(trimmed);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Follow-up comment"
      width="480px"
      closeOnOverlayClick={!isSubmitting}
      closeOnEsc={!isSubmitting}
    >
      <div className="followup-status-modal">
        <p className="followup-status-modal__intro">
          Add a comment for <strong>{statusLabel}</strong>. A comment is required to save this
          follow-up status.
        </p>
        <TextArea
          name="followup_comment"
          value={comment}
          onChange={(e) => {
            setComment(e.target.value);
            if (commentError && e.target.value.trim()) {
              setCommentError(false);
            }
          }}
          placeholder="Enter your comment..."
          isError={commentError}
          errorMessage={commentError ? 'Comment is required' : undefined}
          rows={4}
        />
        <div className="followup-status-modal__actions">
          <Button
            text="Cancel"
            isSecondary
            onClick={handleClose}
            isDisabled={isSubmitting}
          />
          <Button
            text="Save"
            onClick={handleConfirm}
            isLoading={isSubmitting}
            isDisabled={isSubmitting}
          />
        </div>
      </div>
    </Modal>
  );
};

export default FollowupStatusModal;
